(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arvada-faq-nav"] && !Shopify.designMode) return;
  try {
    
  /* Live search across all ARVADA FAQ topics on the page. */
  if (!customElements.get('arvada-faq-search')) {
    customElements.define('arvada-faq-search', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';
        this.input = this.querySelector('input');
        this.status = this.querySelector('[role="status"]');
        let timer;
        this.input.addEventListener('input', () => {
          clearTimeout(timer);
          timer = setTimeout(() => this.filter(this.input.value), 120);
        });
      }

      filter(value) {
        const query = value.trim().toLowerCase();
        const items = Array.from(document.querySelectorAll('.ag__faq-item'));
        let matches = 0;

        items.forEach((item) => {
          const hit = !query || item.textContent.toLowerCase().includes(query);
          item.hidden = !hit;
          if (hit && query) matches += 1;
          if (query.length > 2 && hit && !item.open) {
            item.open = true;
            item.dataset.searchOpened = 'true';
          }
          if (!query && item.dataset.searchOpened === 'true') {
            item.open = false;
            delete item.dataset.searchOpened;
          }
        });

        document.querySelectorAll('.arvada-faq').forEach((section) => {
          section.hidden = Boolean(query) && !section.querySelector('.ag__faq-item:not([hidden])');
        });

        if (!query) {
          this.status.textContent = '';
        } else if (matches === 0) {
          this.status.textContent = this.dataset.empty;
        } else {
          this.status.textContent = matches === 1 && this.dataset.resultsOne ? this.dataset.resultsOne : this.dataset.results.replace('[count]', matches);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arvada-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.arvadaFaqHashReady) return;
    window.arvadaFaqHashReady = true;
    function openFromHash() {
      var id = decodeURIComponent(window.location.hash.slice(1));
      if (!id) return;
      var target = document.getElementById(id);
      if (target && target.tagName === 'DETAILS') {
        target.open = true;
        target.scrollIntoView({ block: 'start' });
      }
    }
    window.addEventListener('hashchange', openFromHash);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', openFromHash);
    } else {
      openFromHash();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arvada-menu-fix"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('arvada-header-sizing')) {
    customElements.define('arvada-header-sizing', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => {
          const header = document.querySelector('.section-header');
          if (!header || !this.isConnected) return;
          this.observer = new ResizeObserver(() => {
            document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
            const sticky = header.querySelector('sticky-header');
            if (Number.isFinite(sticky?.headerBounds?.top) && header.offsetHeight > 0) {
              sticky.headerBounds = { top: sticky.headerBounds.top, bottom: sticky.headerBounds.top + header.offsetHeight };
            }
          });
          this.observer.observe(header);
        });
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
